import { FACE_TO_FACE, MEET } from 'Constants/General';
import { s3 } from 'Services/AWS/s3';
import Firebase from './Firebase';
import {
  UserListCourses,
  UserListPrivateLessons,
  ModuleList,
  LessonList,
  DocumentCourseList,
  UserListUsersByCourse,
} from './Request';

export const fetchCourses = async () => {
  const courses = await UserListCourses({ category: null, name: null });

  const coursePromises = await courses.map(async (course, index) => {
    const promises = [];

    promises.push(ModuleList({ courseId: course.id }).then(data => data.filter(module => module.isDraft !== true)));
    promises.push(DocumentCourseList({ courseId: course.id }));
    promises.push(UserListUsersByCourse({ courseId: course.id }));

    const data = await Promise.all(promises);

    const mappedCourse = {
      ...course,
      modules: data[0],
      documents: data[1],
      members: data[2]?.length,
    };

    courses[index] = mappedCourse;

    return mappedCourse;
  });

  const finalCourses = await Promise.all(coursePromises);
  let documentArray = [];

  finalCourses.forEach(course => {
    documentArray = [...documentArray, ...course.documents];
  });

  documentArray = documentArray.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  documentArray = documentArray.slice(0, 2);

  const documentPromises = documentArray.map(async document => {
    if (document?.url) {
      const response = await s3.getSignedUrl(document.url);
      return response?.signedUrl;
    }

    return document.url;
  });

  const finalDocuments = await Promise.all(documentPromises);

  documentArray = documentArray.map((document, index) => ({
    ...document,
    fileLocation: finalDocuments[index],
  }));

  const filteredCourses = finalCourses.filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i);

  return {
    courses: filteredCourses.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)),
    documents: documentArray.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)),
  };
};

export const fetchSessions = async ({ courses, userId }) => {
  const enrolledPrivateLessons = await UserListPrivateLessons({ userId }).then(data =>
    data.map(lesson => lesson.lessonId)
  );

  const lessonsPromises = await courses.map(async course => {
    const lessonPromises = [];

    course.modules.forEach(module => {
      lessonPromises.push(
        LessonList({ moduleId: module.id }).then(data => {
          const filteredLessons = data.filter(
            lesson =>
              lesson.isDraft !== true && (lesson.isPrivate !== true || enrolledPrivateLessons.includes(lesson.id))
          );

          return [...filteredLessons];
        })
      );
    });

    const fulfilledLessons = await Promise.all(lessonPromises);

    return fulfilledLessons.flat(1);
  });
  let lessons = await Promise.all(lessonsPromises);
  lessons = lessons.flat(1);

  const sessions = lessons.filter(lesson => lesson.LessonType.name === MEET || lesson.LessonType.name === FACE_TO_FACE);

  const remoteSessions = lessons.filter(lesson => lesson.LessonType.name === MEET);

  return {
    sessions: sessions.sort((a, b) => new Date(a.date) - new Date(b.date)),
    remoteSessions: remoteSessions.sort((a, b) => new Date(a.date) - new Date(b.date)),
  };
};

export default { fetchCourses, fetchSessions };
